// extracted by mini-css-extract-plugin
export default {"main":"styles_main__-5-MB","segment":"styles_segment__ZTKd5","pastSegment":"styles_pastSegment__-O+rG"};